import React from 'react';
import PropTypes from 'prop-types';
import { IonItem, IonLabel, IonIcon, IonNote } from '@ionic/react';
import { cardOutline } from 'ionicons/icons';

function MethodItem({ item, ...props }) {
  return (
    <IonItem button {...props}>
      <IonIcon slot="start" icon={cardOutline} />
      <IonLabel>{`XXXX-XXXX-XXXX-${item.lastFourDigits}`}</IonLabel>
      <IonNote slot="end">
        {item.month}/{item.year}
      </IonNote>
    </IonItem>
  );
}

MethodItem.propTypes = {
  item: PropTypes.object,
};

export default MethodItem;
